import * as SparkMD5 from 'spark-md5';
import { message } from 'antd'

export const getFileMd5 = (file: any, progress?: any, total?: number) => {
  return new Promise((resolve) => {
    let tmp_md5;
    let blobSlice =
      File.prototype.slice ||
      File.prototype.mozSlice ||
      File.prototype?.webkitSlice,
      // file = this.files[0],
      chunkSize = 8097152, // Read in chunks of 2MB
      chunks = Math.ceil(file.size / chunkSize),
      currentChunk = 0,
      spark = new SparkMD5.ArrayBuffer(),
      fileReader = new FileReader();

    fileReader.onload = function (e: any) {
      spark.append(e.target?.result); // Append array buffer
      currentChunk++;
      let md5_progress = Math.floor((currentChunk / chunks) * 100);
      console.log(
        file.name + '  正在处理，请稍等,' + '已完成' + md5_progress + '%',
      );
      if (total && md5_progress > 0) {
        progress({
          percent: calculatePagePercentage(md5_progress, total),
        }, file)
      }
      if (currentChunk < chunks) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        loadNext();
      } else {
        tmp_md5 = spark.end();
        console.log(file.name + '的MD5值是：' + tmp_md5);
        resolve(tmp_md5);
      }
    };
    fileReader.onerror = function () {
      console.warn('oops, something went wrong.');
    };
    function loadNext() {
      let start = currentChunk * chunkSize,
        end = start + chunkSize >= file.size ? file.size : start + chunkSize;
      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
    }
    loadNext();
  });
};

export const base64ToFile = (base64String: string, fileName: string) => {
  // 1. 提取 Base64 数据部分（去掉前面的 data:image/png;base64,）
  const byteString = atob(base64String.split(',')[1]);

  // 2. 转换为 Uint8Array（二进制数据）
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }

  // 3. 推断 MIME 类型（如 "image/png"）
  const mimeType = base64String.split(';')[0].split(':')[1] || 'application/octet-stream';

  // 4. 生成 Blob 对象，再转为 File 对象
  const blob = new Blob([arrayBuffer], { type: mimeType });
  return new File([blob], fileName, { type: mimeType });
}

export const getExtension = (filename: string | undefined) => {
  const regex = /\.([a-zA-Z0-9]+)(?:\.([a-zA-Z0-9]+))?(?:\.([a-zA-Z0-9]+))?$/;
  const match = filename?.match(regex);
  if (match) {
    // 合并所有捕获的扩展名
    return match.slice(1).filter(Boolean).join('.');
  }
  return '';
}

const calculatePagePercentage = (currentPage: number, totalPages: number, round = true) => {
  // 参数验证
  if (!Number.isInteger(currentPage) || currentPage < 1) {
    message.error('当前页码必须是大于等于1的整数');
  }
  if (!Number.isInteger(totalPages) || totalPages < 1) {
    message.error('总页数必须是大于等于1的整数');
  }
  if (currentPage > totalPages) {
    return 100; // 超过总页数时返回100%
  }

  // 计算核心逻辑
  let percentage = (currentPage / totalPages) * 100;

  // 处理四舍五入
  if (round) {
    percentage = Math.round(percentage * 100) / 100; // 保留两位小数
  }
  // 格式化输出
  return percentage;
}

// 定义一个函数来判断字符类型
const getCharType = (char: any) => {
  if (/[!@#$%^&*(),.?":{}|<>]/.test(char)) {
    return 1 // 符号
  } else if (/[0-9]/.test(char)) {
    return 2 // 数字
  } else if (/[a-zA-Z]/.test(char)) {
    return 3 // 字母
  } else if (/[\u4e00-\u9fa5]/.test(char)) {
    return 4 // 中文
  }
  return 0 // 其他
}

/** GET 查询参数序列化，确保 [ ] 等特殊字符被 encodeURIComponent 编码 */
export const serializeQueryParams = (params: Record<string, unknown>) => {
  const parts: string[] = [];
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null && item !== '') {
          parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(item))}`);
        }
      });
      return;
    }
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  });
  return parts.join('&');
};

// 名称 升序，降序
export const nameAsceTxt = (a: any, b: any) => {
  const minLength = Math.min(a.length, b.length)
  for (let i = 0; i < minLength; i++) {
    const typeA = getCharType(a[i])
    const typeB = getCharType(b[i])
    if (typeA !== typeB) {
      return typeA - typeB
    }
    if (a[i] !== b[i]) {
      return a[i].localeCompare(b[i])
    }
  }
  return a.length - b.length
}